import { Component, OnInit, Inject } from '@angular/core';
import { FolderDialogData, MediaFolder, Error, FolderMoveResultData, FolderNode } from 'src/app/utils/common-classes';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { FolderService } from 'src/app/services/Folder/folder.service';
import { UtilsService } from 'src/app/services/Utils/utils.service';

@Component({
  selector: 'app-move-folder-dialog',
  templateUrl: './move-folder-dialog.component.html',
  styleUrls: ['./move-folder-dialog.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '32px',
        opacity: 1,
      })),
      state('closed', style({
        height: '0px',
        opacity: 0
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ],
})
export class MoveFolderDialogComponent implements OnInit {
  public selectedFolder: FolderNode;
  public moveFolderError: string;

  constructor(
    public dialogRef: MatDialogRef<MoveFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FolderDialogData,
    private folderService: FolderService,
    public utils: UtilsService) { }

  ngOnInit() {
  }

  public onAbortClick(): void {
    this.dialogRef.close(null);
  }

  public onSelectClick(): void {
    let _self = this;
    _self.utils.showShortLoader();
    _self.folderService.moveFolder(_self.data.node.mediaFolderId, _self.selectedFolder.mediaFolderId).then((folder: MediaFolder) => {
      let resultFolderMoveResultData: FolderMoveResultData = new FolderMoveResultData(folder, _self.selectedFolder.mediaFolderId ? _self.selectedFolder : null);
      _self.dialogRef.close(resultFolderMoveResultData);
    }).catch((err) => {
      return _self.utils.getError(err);
    }).then((translatedError) => {
      if (translatedError) {
        _self.moveFolderError = translatedError;
      }
    }).finally(() => {
      _self.utils.hideShortLoader();
    });
  }

  public selectFolder(node: FolderNode): void {
    let _self = this;
    _self.selectedFolder = node;
  }
}
